export interface ITimestamp {
    key: number;
    value: number;
    text: string;
    verticesmapkey: string;
    cgmtimestamp: string;
    popupdescription?: string;
}

export function isITimestamp(obj: any): obj is ITimestamp {
    return (
        typeof obj === 'object' &&
        typeof obj.key === 'number' &&
        typeof obj.value === 'number' &&
        typeof obj.text === 'string' &&
        typeof obj.verticesmapkey === 'string' &&
        typeof obj.cgmtimestamp === 'string'
    );
}

export interface KeyValue {
    key: string;
    value: string;
}

/*
export const timestamps: ITimestamp[] = [
    { key: 0, value: 0, text: "00:30" },
    { key: 1, value: 1, text: "01:30" },
    { key: 2, value: 2, text: "02:30" },
    { key: 3, value: 3, text: "03:30" },
    { key: 4, value: 4, text: "04:30" },
    { key: 5, value: 5, text: "05:30" },
    { key: 6, value: 6, text: "06:30" },
    { key: 7, value: 7, text: "07:30" },
    { key: 8, value: 8, text: "08:30" },
    { key: 9, value: 9, text: "09:30" },
    { key: 10, value: 10, text: "10:30" },
    { key: 11, value: 11, text: "11:30" },
    { key: 12, value: 12, text: "12:30" },
    { key: 13, value: 13, text: "13:30" },
    { key: 14, value: 14, text: "14:30" },
    { key: 15, value: 15, text: "15:30" },
    { key: 16, value: 16, text: "16:30" },
    { key: 17, value: 17, text: "17:30" },
    { key: 18, value: 18, text: "18:30" },
    { key: 19, value: 19, text: "19:30" },
    { key: 20, value: 20, text: "20:30" },
    { key: 21, value: 21, text: "21:30" },
    { key: 22, value: 22, text: "22:30" },
    { key: 23, value: 23, text: "23:30" },
];
*/

export function create24Timestamps() {
    let timestampsArray: ITimestamp[] = [];
    for (let i = 0; i <= 23; i++) {
        let hourString = i.toString();
        if (i < 10) {
            hourString = '0' + hourString;
        }
        const hourTimestamp = `${hourString}:30`;
        const cgmTimestamp = `${hourString}30`;
        timestampsArray.push({ key: i, value: i, cgmtimestamp: cgmTimestamp, verticesmapkey: i.toString(), text: hourTimestamp })
    }
    return timestampsArray;
};

export function create24Scenarios() {
    let timestampsArray: ITimestamp[] = [];
    for (let i = 0; i <= 23; i++) {
        let hourString = i.toString();
        if (i < 10) {
            hourString = '0' + hourString;
        }
        const scenarioString = `S${hourString}`;
        timestampsArray.push({ key: i, value: i, cgmtimestamp: scenarioString, verticesmapkey: scenarioString, text: scenarioString })
    }
    return timestampsArray;
};

export function create18Timestamps() {
    let timestampsArray: ITimestamp[] = [];
    for (let i = 6; i <= 23; i++) {
        let hourString = i.toString();
        if (i < 10) {
            hourString = '0' + hourString;
        }
        const hourTimestamp = `${hourString}:30`;
        const cgmTimestamp = `${hourString}30`;
        timestampsArray.push({ key: i, value: i, cgmtimestamp: cgmTimestamp, verticesmapkey: i.toString(), text: hourTimestamp })
    }
    return timestampsArray;
};

export function create12Timestamps() {
    let timestampsArray: ITimestamp[] = [];
    for (let i = 12; i <= 23; i++) {
        let hourString = i.toString();
        if (i < 10) {
            hourString = '0' + hourString;
        }
        const hourTimestamp = `${hourString}:30`;
        const cgmTimestamp = `${hourString}30`;
        timestampsArray.push({ key: i, value: i, cgmtimestamp: cgmTimestamp, verticesmapkey: i.toString(), text: hourTimestamp })
    }
    return timestampsArray;
};

export function create6Timestamps() {
    let timestampsArray: ITimestamp[] = [];
    for (let i = 18; i <= 23; i++) {
        let hourString = i.toString();
        if (i < 10) {
            hourString = '0' + hourString;
        }
        const hourTimestamp = `${hourString}:30`;
        const cgmTimestamp = `${hourString}30`;
        timestampsArray.push({ key: i, value: i, cgmtimestamp: cgmTimestamp, verticesmapkey: i.toString(), text: hourTimestamp })
    }
    return timestampsArray;
};

export function createAvailableScenarios(scenariosArray: KeyValue[]) {
    let timestampsArray: ITimestamp[] = [];
    for (let i = 0; i < scenariosArray.length; i++) {
        const scenarioString = scenariosArray[i].key;
        timestampsArray.push({ key: i, value: i, cgmtimestamp: scenarioString, verticesmapkey: scenarioString, text: scenarioString, popupdescription: scenariosArray[i].value })
    }

    return timestampsArray;
};

export function create24OnlyHourTimestamps() {
    let timestampsArray = [];
    for (let i = 0; i <= 23; i++) {
        timestampsArray.push(i.toString())
    }
    return timestampsArray;
};

export const allTimestamps = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
];
